var map = {
	"./dates.json": 3868,
	"./inventory.json": 3869,
	"./packages.json": 3870,
	"./paymentMethods.json": 3871,
	"./prices.json": 3872,
	"./reservation.json": 3873,
	"./sails.json": 3874
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3867;